import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Main from '@/components/main'
import Forward from '@/components/Forward';

Vue.use(Router)



export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/main',
      name: 'main',
      component: Main
    },
    {
      path: '/forward',
      name: 'forward',
      component: Forward
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js